export default __webpack_public_path__ + "static/media/cover-1.b2b552ab.webp";